import { render, staticRenderFns } from "./FeaturedArticle.vue?vue&type=template&id=79985c3e&scoped=true"
import script from "./FeaturedArticle.vue?vue&type=script&lang=js"
export * from "./FeaturedArticle.vue?vue&type=script&lang=js"
import style0 from "./FeaturedArticle.vue?vue&type=style&index=0&id=79985c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79985c3e",
  null
  
)

export default component.exports